import { Input, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-dialog-footer',
  standalone: true,
  imports: [],
  templateUrl: './dialog-footer.component.html',
  styleUrl: './dialog-footer.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-dialog-footer',
    '[class]': '"app-dialog-footer_" + justifyContent',
  },
})
export class DialogFooterComponent {
  @Input() justifyContent: 'space-between' | 'center' | 'start' | 'end' = 'space-between';
}
